export default "__VITE_ASSET__CPm2bLs8__"